"use strict"
import Axios from "../../../services/AxiosService"

class Service extends Axios {
  constructor() {
    super()
  }
  getRouteItem(id: number) {
    return this.request({
      method: "GET",
      url: `route-items/${id}`,
    })
  }

  async patch({ vuex, ...data }: any) {
    return this.request({
      method: "PATCH",
      url: `route-items/${data.id}`,
      data,
      offline: true,
      vuex,
    })
  }

  getReasonForNotSigning() {
    return this.request({
      method: "GET",
      url: "/reason-for-not-signings",
    })
  }
  async start(vuex: any, routeItem: any) {
    return this.request({
      method: "PATCH",
      url: `route-items/${routeItem.id}/start`,
      data: routeItem,
      offline: true,
      vuex,
    })
  }

  async access(id: number) {
    return this.request({
      method: "GET",
      url: `route-items/route-item-access/${id}`,
    })
  }

  async jobs() {
    return this.request({
      method: "GET",
      url: `/jobs`,
    })
  }

  async abnormalities() {
    return this.request({
      method: "GET",
      url: "/abnormalities",
    })
  }

  async serviceTypes() {
    return this.request({
      method: "get",
      url: "/service-types",
    })
  }

  async providers() {
    return this.request({
      method: "get",
      url: "/providers",
    })
  }

  async create({ data, vuex }: any) {
    return this.request({
      method: "post",
      url: "route-items",
      data,
      offline: true,
      vuex,
    })
  }
}

export default () => new Service()
